import styled, { css } from 'styled-components'

import { CTAButton } from 'src/Components/Buttons/CTAButton'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'

export const CampaignUpsellContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.mediumRed};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
`
export const CampaignUpsellButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;
`
export const CampaignUpsellTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

export const CampaignUpsellTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

export const CampaignUpsellButtonContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
`

export const Accent = styled.span`
  color: ${({ theme }) => theme.color.brandGreen};
`

export const CTAStyledButton = styled(CTAButton)`
  min-width: 278px;
`

export const ButtonContent = styled(CampaignUpsellButtonContent)<{
  $onCta?: boolean
}>`
  ${({ theme, $onCta }) =>
    !$onCta &&
    css`
      svg path {
        fill: ${theme.color.darkGrey};
      }
    `}
`
export const Container = styled(CampaignUpsellContainer)<{
  $highlighted?: boolean
}>`
  ${({ theme, $highlighted }) =>
    $highlighted &&
    css`
      border: 1px solid ${theme.color.brandGreen};
    `}
`

export const Text = styled(CampaignUpsellTitle)`
  font-size: 14px;
  font-weight: 400;
`

export const CampaignUpsellText = styled(Text)`
  display: flex;
  gap: 20px;
  flex-direction: column;

  > p {
    margin-bottom: 0;
  }
`
export const StyledGreyTextButton = styled(GreyTextButton)`
  min-width: 278px;
`
